import React, { useState } from 'react';
import { Modal, Input, Checkbox, Button, Form, Typography, Row, Col, Flex, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import styles from './styles.module.scss';
import { useNavigate } from 'react-router-dom';

const { Title, Link } = Typography;

const CreateAccountModal = ({ open, onCancel, onCreate }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [consent, setConsent] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      console.log('Form values:', values);
      await onCreate(values);
      // navigate('/dashboard/decarbonizator');
    } catch (err) {
      console.error('Error validation');
    }
  };

  return (
    <Modal open={open} onCancel={onCancel} footer={null} closable centered width={600}>
      <div style={{ padding: '10px 0' }}>
        <Title level={4} style={{ marginBottom: 4 }}>
          For secure access and storage of certificates,
          <br className={styles.mobileHide} /> create a password{' '}
          <Tooltip
            title="GreenifAI is part of TransparenTerra, a comprehensive sustainability platform operated by FCE Group AG. Once you verify your email, you’ll be instantly registered on TransparenTerra to enable issuance, storage and management of your carbon offset certificates."
            color="rgba(0, 0, 0, 0.6)"
          >
            <QuestionCircleOutlined style={{ fontSize: 18, color: '#555', cursor: 'pointer' }} />
          </Tooltip>
        </Title>
        <Link
          style={{ color: '#18397A', textDecoration: 'underline' }}
          href="https://greenifai.shopping/terms-of-services"
          target="_black"
        >
          Learn more
        </Link>
      </div>

      <Form className={styles.formBlock} form={form} layout="vertical" requiredMark={false}>
        <Row gutter={16}>
          <Col xs={24} md={12} className={styles.passwordInput}>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Please enter a password' },
                {
                  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[!-~]{8,64}$/,
                  message:
                    'Password must be at least 8 characters, include uppercase, lowercase letters and a number',
                },
              ]}
            >
              <Input.Password placeholder="Password*" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="confirmPassword"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please confirm your password' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Passwords do not match'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm Password*" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ margin: '12px 0px' }}>
          <Checkbox checked={consent} onChange={(e) => setConsent(e.target.checked)}>
            I consent to GreenifAI processing my email for issuance and distribution of the offset
            certificates.{' '}
            <Link
              style={{ color: '#18397A', textDecoration: 'underline' }}
              href="https://greenifai.shopping/privacy-notice"
              target="_black"
            >
              Learn more
            </Link>
          </Checkbox>
        </Form.Item>

        <Form.Item style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
          <Flex className={styles.buttonBlock} justify="space-between" style={{ width: '100%' }}>
            <Button onClick={onCancel} className={styles.cancelButton}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSubmit} className={styles.createButton}>
              Continue
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateAccountModal;
